import { BoldTextButton } from "thrive-components";
import { getRecognitionPostTitle } from "../notificationTitles.service";



export interface IRecognitionPostTitle {
    parentList?: {
        id: number;
        title: string;
        link: string;
    }
    user: string;
    recognisedUser: string;      
    isPopOut?: boolean
}

const RecognitionPostTitle = ({user, recognisedUser, parentList, isPopOut}: IRecognitionPostTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle, hasContentLink} = getRecognitionPostTitle({parentList, user, recognisedUser, isPopOut})

    return (
        <span className={className}>
            {activityInformation}

            {hasContentLink &&  
                <BoldTextButton 
                    ariaLabel={contentLinkAriaLabel} 
                    link={contentLink} 
                    text={contentLinkTitle ?? ""} 
                />
            }
        </span>
    );
};
export default RecognitionPostTitle;
